// Admin Users Management
import { useQuery, useMutation, useQueryClient } from 'react-query';

export default function AdminUsers() {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery('users', async () => {
    const res = await fetch('/api/users', { credentials: 'include' });
    return res.json();
  });
  
  return (
    <div>
      <h1 className="font-heading text-3xl font-bold mb-6">Users</h1>
      <div className="card bg-base-100 shadow">
        <div className="card-body">
          {isLoading ? <span className="loading loading-spinner loading-lg text-primary"></span> : (
            <div className="overflow-x-auto">
              <table className="table">
                <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Actions</th></tr></thead>
                <tbody>
                  {data?.data?.map((user: any) => (
                    <tr key={user.id}>
                      <td>{user.firstName} {user.lastName}</td>
                      <td>{user.email}</td>
                      <td><span className={`badge ${user.role === 'SUPER_ADMIN' ? 'badge-error' : user.role === 'OWNER_ADMIN' ? 'badge-primary' : user.role === 'STAFF' ? 'badge-secondary' : 'badge-ghost'}`}>{user.role}</span></td>
                      <td><span className={`badge ${user.isActive ? 'badge-success' : 'badge-error'}`}>{user.isActive ? 'Active' : 'Inactive'}</span></td>
                      <td><button className="btn btn-ghost btn-sm">Edit</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}